// extracted by mini-css-extract-plugin
module.exports = {"container":"GiftPage_container__16QHG","gifts-title":"GiftPage_gifts-title__3KLNg","title":"GiftPage_title__2IG9k","list-gifts":"GiftPage_list-gifts__ur_bH"};